// extracted by mini-css-extract-plugin
export default {"base":"EmptyMap_base__PBEa-","loading":"EmptyMap_loading__aqTx3"};